import { createContext, useContext } from "react";
import { SettingsContextType, LangChangeContextType } from "./types";

export const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined,
);

export const useSettings = () =>
  useContext(SettingsContext) as SettingsContextType;

export const LangChangeContext = createContext<LangChangeContextType>({
  langChangeUseEffect: true,
  setLangChangeUseEffect: () => {},
});
